"use client"

import {
  NavigateWithThread,
  EntityDetailSkeleton,
  useEvaluationSummary,
  buildEmployerPersonMatchPath,
  getHrefWithThreadPreservation,
} from '@yeshuman/sdk'
import { useParams } from 'react-router-dom'

export function JobWorkspaceEvaluationDetailPage() {
  const { jobId = '', evaluationId } = useParams<{ jobId: string; evaluationId: string }>()
  const { evaluation, isLoading } = useEvaluationSummary(evaluationId)

  if (!evaluationId || !jobId) {
    return <NavigateWithThread to={jobId ? `/employer/jobs/${jobId}/talent` : '/employer/jobs'} />
  }

  if (isLoading) {
    return <EntityDetailSkeleton variant="job" ariaLabel="Loading match analysis" />
  }

  const profileId = evaluation?.profile_id
  if (!profileId) {
    return <NavigateWithThread to={`/employer/jobs/${jobId}/talent`} />
  }

  const target = buildEmployerPersonMatchPath(jobId, profileId, {
    evaluationId,
  })

  return <NavigateWithThread to={getHrefWithThreadPreservation(target)} />
}
